import { paceStatusIcon } from "enums/paceStatus";
import { AssessmentCentreUser, UserAssessments } from "services/assessmentCentre";
import { RequestInfo } from "store/slice/store.types";
import { Pagination } from "types/global";
import { generateID } from "utils/utils";

export type ConvertedAssessmentCentre = {
    data: ConvertedAssessmentCentreUserData[];
    meta: Pagination;
    status: RequestInfo;
};

export type AssessmentCentrePaceStatus = keyof typeof paceStatusIcon;

export type ConvertedAssessmentCentreUserData = {
    id: number;
    userName: string;
    email: string;
    linkedinId: string | null;
    lastContactedOn: null | Date;
    paceStatus: AssessmentCentrePaceStatus;
    assessments: UserAssessments[];
    teams: { id: number; name: string }[];
    checked: boolean;
    personId: number | null;
};

export const convertUserAssessmentList = (data: AssessmentCentreUser[]): ConvertedAssessmentCentreUserData[] => {
    return data.map((userData) => {
        return {
            id: userData.id,
            userName: userData.name,
            email: userData.email,
            linkedinId: userData.person.linkedin_id,
            lastContactedOn: userData.last_contacted_datetime ?? null,
            paceStatus: userData.pace_status as AssessmentCentrePaceStatus,
            assessments: userData.user_assessments,
            teams: userData.teams.map((team) => ({ ...team, id: generateID() })),
            checked: false,
            personId: userData.person.id,
        };
    });
};
